//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import gameCont from '../game/index.vue'
import homeDialog from './components/home-dialog.vue'
import HomeXDialog from './components/home-x-dialog.vue'
import HomeFooter from './components/home-footer.vue'
import PNotice from './components/p-notice/'
import { getGameTypeList } from '@/common/api/game.js'
import { goSlotGame, goGame,goSpecialFishGame, goSpecificGame,fastGoGame} from '@/common/utils/common.js';
import { mapState, mapMutations } from 'vuex'

import {
    commonApi,
  } from "@/common/index";
export default {
    name: "home",
    components: { homeDialog, HomeXDialog, gameCont, PNotice, HomeFooter },
    data() {
        return {
            gameTypeCode: '-1',
            tabIndex: 0,
            tabOptions: [],
            include: [],
            isHide: true,
            homePendant: null, //首页挂件
            homeBonus: null,// 右下角挂件
            qMenuStyle: {},
            homeGameListNew:[],
            nowIndex: 0,
            ifrTitle: '',
        }
    },
    directives: {
        'horizontal-scroll': {
            bind: function (el) {
                el.addEventListener('wheel', function (event) {
                    event.preventDefault();
                    el.scrollLeft += event.deltaY;
                });
            }
        }
    },
    computed: {
        ...mapState({
            FrontConfigList: state => state.FrontConfigList,
            eventBanner: state => state.eventBanner,
            isLogin: state => state.isLogin,
        })
    },
    watch:{
        $route: {
            handler(v) {
                // let path = this.$route.path
                    this.reJump();
            },
            deep: true
            }
    },
    created() {
        this._getH5();
        this.reJump();
        const storedArray = sessionStorage.getItem('homeNav');
        if (storedArray) {
            this.tabOptions = JSON.parse(storedArray);
        }else{
            this.setTabList()
        }

    },
    methods: {
        ...mapMutations(["SET_NAV_LIST", "SET_COLOR_DOWNLOADSHOW", 'SET_LOGIN_SHOW', "set_bottom"]),
        _getH5() { // 获取H5挂件信息
            if (sessionStorage.getItem('h5HomePendant')) {
                this.homePendant = JSON.parse(sessionStorage.getItem('h5HomePendant'));
            } else {
                commonApi.HOMEBEFORE.getHomePendant('h5HomePendant').then((data) => {
                    this.homePendant = data;
                    if (data) {
                        sessionStorage.setItem("h5HomePendant", JSON.stringify(data));
                    }
                })
            }

            if (sessionStorage.getItem('BONUS')) {
                this.homeBonus = JSON.parse(sessionStorage.getItem('BONUS'));
            } else {
                commonApi.HOMEBEFORE.getHomePendant('BONUS').then((data) => {
                    this.homeBonus = data;
                    if (data) {
                        sessionStorage.setItem("BONUS", JSON.stringify(data));
                    }
                })
            }
        },
        setTabList(){
            let _ajax = getGameTypeList
             let params = {}
             _ajax(params).then(([data, err, res]) => {
                if (data) {
                    this.tabOptions =data;
                    var checkedIdStr = JSON.stringify(data);
                    sessionStorage.setItem("homeNav", checkedIdStr);
                }
            })
        },
        reJump() {
            const gameTypeQuery = this.$route.query.gameType;
            if(gameTypeQuery){ //从热门过来的链接判断tabIndex
                const storedArray = sessionStorage.getItem('homeNav');
                if (storedArray) {
                    this.homeGameListNew = JSON.parse(storedArray);
                }  
                for(let i = 0; i < this.homeGameListNew.length; i++) {
                    if(gameTypeQuery == this.homeGameListNew[i].gameType){
                        this.tabIndex = i;
                        sessionStorage.setItem('tabIndex', this.tabIndex);
                    }
                }    
                const index = parseFloat(sessionStorage.getItem('tabIndex'));
                setTimeout(()=>{
                    this.$nextTick(() => {
                        const item = this.$el.querySelectorAll('.navbar-item')[index]
                        const container = document.querySelector('#flexImd')
                        const scrollLeft = item.offsetLeft - (container.offsetWidth - item.offsetWidth) / 2
                        container.scrollTo({
                        left: scrollLeft,
                        behavior: 'smooth'
                        })
                    })                  
                },300)        
            }else{
                if(this.$route.name === 'home'){
                    this.nowIndex = 0;
                    this.tabIndex = this.nowIndex;
                    sessionStorage.setItem('tabIndex', 0);
                }else{
                    this.tabIndex = parseFloat(sessionStorage.getItem('tabIndex'));
                }
                setTimeout(()=>{
                    this.$nextTick(() => {
                        const item = this.$el.querySelectorAll('.navbar-item')[this.tabIndex]
                        const container = document.querySelector('#flexImd')
                        const scrollLeft = item.offsetLeft - (container.offsetWidth - item.offsetWidth) / 2
                        container.scrollTo({
                        left: scrollLeft,
                        behavior: 'smooth'
                        })
                    })                  
                },300)
            }
          
        },
        async chooseNav ({ tabIndex }) {
            this.$nextTick(() => {
                const item = this.$el.querySelectorAll('.navbar-item')[tabIndex]
                const container = document.querySelector('#flexImd')
                const scrollLeft = item.offsetLeft - (container.offsetWidth - item.offsetWidth) / 2
                container.scrollTo({
                left: scrollLeft,
                behavior: 'smooth'
                })
            })
            const { gameType, tag, eventLink,eventLinkType, appOpenMethod,gameTypeName } = this.tabOptions[tabIndex]
            if (gameType === '99') { //非游戏导航跳转处理
                if(tag != 'event'){ //跳自己定义的链接
                    if(tag === 'hot'){ //热门
                        this.$router.push({ path: '/'})
                    }else if(tag === 'agent'){//代理
                        this.$router.push({ path: '/agency'})
                    }else if(tag === 'bonus'){//优惠
                        this.$router.push({ path: '/promotions'})
                    }else if(tag === 'withdraw'){//取款
                        this.$router.push({ path: '/withdraw/audit'})
                    } else if(tag === 'record'){//注单记录
                        this.$router.push({ path: '/My/bet-record'})
                    } else if(tag === 'deposit'){//存款
                        this.$router.push({ path: '/deposit'})
                    } else if(tag === 'app'){//app
                        window.open(this.$store.state.linkList.appDownload)
                    } else if(tag === 'account'){//个人中心
                        this.$router.push({ path: '/My'})
                    } else if(tag === 'invite'){//邀请
                        this.$router.push({ path: '/My/InviteFriends'})
                    } else if(tag === 'message'){//消息
                        this.$router.push({ path: '/inbox'})
                    } 
                }else{ //跳eventLink返回的链接
                    if (this.$store.state.isLogin) {
                        if(eventLinkType === '2'){ //需要处理的链接
                            if(appOpenMethod ==='1'){ //内嵌游戏
                                const links = eventLink.substring(eventLink.lastIndexOf("?") + 1)
                                const arrParams = links.split('&');
                                let objParams = {}
                                for (let i = 0; i <arrParams.length; i++) {
                                    const arrKey = arrParams[i].split('=');
                                    objParams[arrKey[0]] = arrKey[1]
                                    // if (arrKey[0] === 'platformKey') {
                                    // objParams.fullName = arrKey[1]
                                    // }
                                }
                                if (eventLink.split('?')[0] === '/launchGame') {  // 进入具体游戏
                                    let gameUrl = '';
                                    let res = {};
                                    this.ifrTitle = gameTypeName || ''
                                    if(gameType === '1'){
                                        res = await goSlotGame(objParams, this.$store.state.isLogin, this.$store.state.UUID, 1) // 电子
                                        gameUrl = res.gameUrl
                                        // this.$router.push({ path: '/game/iframe', query: { ifrUrl:gameUrl } })
                                        }else if(gameType === '5'){
                                        res = await goSpecialFishGame(objParams, this.$store.state.isLogin, this.$store.state.UUID, 1) //捕鱼
                                        gameUrl = res.gameUrl
                                        }else if(gameType === '6'){
                                        res = await goSpecificGame(objParams, this.$store.state.isLogin, this.$store.state.UUID, 1) //棋牌
                                        gameUrl = res.gameUrl
                                        }else{
                                        // gameUrl = goGame(objParams, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                                        res = await fastGoGame(objParams, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                                        gameUrl = res.gameUrl
                                        }
                                        this.$router.push({ path: '/game/iframe', query: { ifrUrl:encodeURIComponent(gameUrl), ifrTitle: encodeURIComponent(this.ifrTitle), fromUrl: encodeURIComponent(this.$route.path) } })
                                    return
                                }
                            }else{
                                const links = eventLink.substring(eventLink.lastIndexOf("?") + 1)
                                const arrParams = links.split('&');
                                let objParams = {}
                                for (let i = 0; i <arrParams.length; i++) {
                                    const arrKey = arrParams[i].split('=');
                                    objParams[arrKey[0]] = arrKey[1]
                                    // if (arrKey[0] === 'platformKey') {
                                    // objParams.fullName = arrKey[1]
                                    // }
                                }
                                if (eventLink.split('?')[0] === '/launchGame') {  // 进入具体游戏
                                    if (gameType === '1') {
                                    goSlotGame(objParams, this.$store.state.isLogin, this.$store.state.UUID)
                                    } else if (gameType !== '1') {
                                    goGame(objParams, this.$store.state.isLogin, this.$store.state.UUID)
                                    }
                                    return
                                } else if (eventLink.split('?')[0] === '/launchGameType' || eventLink.split('?')[0] === '/launchGamePlatform'){
                                    let path = ''
                                    if (gameType === '1' && this.$route.path !== '/gamelobby/egame') {
                                    path = '/gamelobby/egame'
                                    }
                                    if (gameType === '2' && this.$route.path !== '/gamelobby/live') {
                                    path = '/gamelobby/live'
                                    }
                                    if (gameType === '3' && this.$route.path !== '/gamelobby/sports') {
                                    path = '/gamelobby/sports'
                                    }
                                    if (gameType === '4' && this.$route.path !== '/gamelobby/lottery') {
                                    path = '/gamelobby/lottery'
                                    }
                                    if (gameType === '5' && this.$route.path !== '/gamelobby/fish') {
                                    path = '/gamelobby/fish'
                                    }
                                    if (gameType === '6' && this.$route.path !== '/gamelobby/chess') {
                                    path = '/gamelobby/chess'
                                    }
                                    if (eventLink.split('?')[0] === '/launchGamePlatform' && platformCode) {
                                    setTimeout(()=>{
                                        this.$store.commit('setEventPlatFormCode', platformCode)
                                    }, 1200)
                                    }
                                    if (path !== '') {
                                    setTimeout(()=>{
                                        this.$store.commit('setEventBanner', Number(gameType))
                                    })
                                    this.$router.push({
                                        path
                                    })
                                    }
                                }
                            }
                        }else{
                            this.$router.push({ path: eventLink })
                        }
                    }else{
                        this.$router.push({ path: '/login' })
                    }
                }
            } else {  //游戏导航跳转
                this.tabIndex = tabIndex;
                sessionStorage.setItem('tabIndex', this.tabIndex);
                this.gameTypeCode = gameType
                if (gameType === '1') {
                    this.$router.push({ path: '/gamelobby/egame' })
                }else if (gameType === '2') {
                    this.$router.push({ path: '/gamelobby/live' })
                }else if (gameType === '3') {
                    this.$router.push({ path: '/gamelobby/sports' })
                }else if (gameType === '4') {
                    this.$router.push({ path: '/gamelobby/lottery' })
                }else if (gameType === '5') {
                    this.$router.push({ path: '/gamelobby/fish' })
                }else if (gameType === '6') {
                    this.$router.push({ path: '/gamelobby/chess' })
                }else if (gameType === '7') {
                    this.$router.push({ path: '/gamelobby/Classic' })
                }else if (gameType === '8') {
                    this.$router.push({ path: '/gamelobby/bingo' })
                }              
            }
        },

        handleH5({ imgClickLink }) { // 点击H5挂件操作
            if (imgClickLink === '') return
            if (imgClickLink.indexOf('http') === -1) {
                this.$router.push({ path: imgClickLink.replace('#', '') })
            } else {
                window.open(imgClickLink)
            }
        },
    },
    mounted(){
        if(this.$route.name === 'home'){
            this.tabIndex = 0
           sessionStorage.setItem('tabIndex', 0);
        }else{
            this.tabIndex = parseFloat(sessionStorage.getItem('tabIndex'));
        }
    },
};



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/index.vue